module.exports = __webpack_public_path__ + "9866dc8211a3261ecfef7978370b14b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/jinrong1.png
// module id = 256
// module chunks = 3